
import ActualizacionDatosModel from "@/models/ActualizacionDatos/ActualizacionDatosModel";
import GlobalConfig from "@/GlobalConfig";
import ContactComponent from "@/components/Actualizacion_Datos/ContactComponent.vue";
import UmbracoApiService from "@/services/UmbracoApiService";
import { AxiosResponse } from "axios";
import { Component, Vue, Watch } from "vue-property-decorator";
import UserResponse from "@/models/WsdlResponses/UserResponse";
import WsdlService from "@/services/WsdlService";
import Swal from "sweetalert2";
import { formatFechaAfpSiembra } from "@/utils/HelperFunctions";
import User from "@/models/User";
import AfpUser, { AfpUserContact } from "@/models/AfpUser";
import { Getter } from "vuex-class";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import CityResponse from "@/models/WsdlResponses/CityResponse";
import ZoneResponse from "@/models/WsdlResponses/ZoneResponse";
import AfpUserServiceContact, {
  UserContact,
} from "@/models/AfpUserServiceContact";
import LoginService from "@/services/LoginService";
import LoginModel from "@/models/LoginModel";
import { AlertPlugin } from "bootstrap-vue";
import EmailValidator from "@/utils/EmailValidator";

@Component({
  components: {
    ContactComponent,
  },
})
export default class ActualizacionDatos extends Vue {
  @Getter("user") userGetter: User;

  public loginModel = new LoginModel();
  public email: string = this.$store.state.user.correoElectronico1;
  public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
  public userId: string = this.$store.state.user.cedula;
  public user: UserResponse = new UserResponse();
  public afpUser: AfpUser = new AfpUser();
  public contacts: Array<AfpUserContact> = [];
  public loadContacts: boolean = false;
  public isProcessing: boolean = false;
  public checkProcesar: boolean = false;
  public loginService = new LoginService();
  public cityHome: CityResponse = null;
  public cityWork: CityResponse = null;
  public zoneHome: ZoneResponse = null;
  public zoneWork: ZoneResponse = null;
  public cities: Array<Option<CityResponse>> = [];
  public zones: Array<Option<ZoneResponse>> = [];
  public zonesHome: Array<Option<ZoneResponse>> = [];
  public zonesWork: Array<Option<ZoneResponse>> = [];
  public wsdlService: WsdlService = new WsdlService();
  public isLoadingZone: boolean = false;
  public isLoadingCity: boolean = false;
  public umbracoService = new UmbracoApiService();
  public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
  public actualizacionDatos = new ActualizacionDatosModel();
  public contactsArray: Array<AfpUserContact> = [];
  public isEmailValid: boolean = true;

  public selectedCityHome: CityResponse = null;
  public selectedCityWork: CityResponse = null;
  public selectedZoneHome: ZoneResponse = null;
  public selectedZoneWork: ZoneResponse = null;

  @Getter("user") loggedInUser: User;
  async created() {
    const safeCall = async (fn: () => any, name: string) => {
      try {
        await fn(); // si es sync no pasa nada, si es async, await lo espera
      } catch (e) {
        console.error(`${name} falló:`, e);
      }
    };

    await safeCall(() => this.getUser(this.userId), "getUser");
    await safeCall(() => this.getCities(), "getCities");
    await safeCall(() => this.getUserContacts(this.userId), "getUserContacts");
    await safeCall(() => this.formatEmailFromParts(), "formatEmailFromParts");
    await safeCall(() => this.getData(), "getData");
  }

  public async formatEmailFromParts() {
    console.log("this.afpUser", this.afpUser);
    if (this.afpUser.emailusuario && this.afpUser.emailservidor) {
      this.afpUser.emailusuario =
        this.afpUser.emailusuario.toLowerCase() +
        "@" +
        this.afpUser.emailservidor.toLowerCase();
    }
  }

  public async mounted() {
    if (this.afpUser.emailusuario != null) {
      this.afpUser.emailusuario =
        this.afpUser.emailusuario.toLowerCase() +
        this.afpUser.emailservidor.toLowerCase();
    }
  }
  public async getUser(userId: string) {
    const response = await this.wsdlService.getUser(
      userId,
      this.loggedInUser.password
    );
    this.afpUser = response.data;
  }

  public async setCities() {
    let cityHomeFiltered = this.cities.find(
      (city) => city.value.ciudad == this.afpUser.codciudaD1
    );

    console.log("cityHomeFiltered", cityHomeFiltered);
    this.cityHome = cityHomeFiltered.value;
    let cityWorkFiltered = this.cities.find(
      (city) => city.value.ciudad == this.afpUser.codciudaD2
    );
    this.cityWork = cityWorkFiltered.value;
    this.selectedCityHome = cityHomeFiltered?.value;
    this.selectedCityWork = cityWorkFiltered?.value;

    // this.cityHome.ciudad =this.afpUser.codciudaD1 ;
    // this.cityWork.ciudad = this.afpUser.codciudaD2 ;
    // this.zoneHome.descripcion = this.afpUser.sectoR1 ;
    // this.zoneWork.descripcion = this.afpUser.sectoR2 ;
    // this.cityHome.descripcion =  this.afpUser.ciudaD1
    // this.cityWork.descripcion = this.afpUser.ciudaD2 ;
    // this.zoneHome.sector = this.afpUser.codsectoR1 ;
    // this.zoneWork.sector = this.afpUser.codsectoR2 ;
  }
  public getCities(city: string = "") {
    this.isLoadingCity = true;
    this.wsdlService
      .GetCiudades(city)
      .then((response: AxiosResponse<Array<CityResponse>>) => {
        this.cities = response.data.map((respObj: CityResponse) => ({
          value: respObj,
          text: respObj.descripcion,
          disabled: false,
        }));
        this.isLoadingCity = false;
      });
  }
  public getZones(city: string, zone: string = "", home: boolean) {
    this.isLoadingZone = true;
    this.wsdlService
      .GetSectores(city, zone)
      .then((response: AxiosResponse<Array<ZoneResponse>>) => {
        this.zones = response.data.map((respObj: ZoneResponse) => ({
          value: respObj,
          text: respObj.descripcion,
          disabled: false,
        }));
        if (home) {
          this.zonesHome = response.data.map((respObj: ZoneResponse) => ({
            value: respObj,
            text: respObj.descripcion,
            disabled: false,
          }));
        } else {
          this.zonesWork = response.data.map((respObj: ZoneResponse) => ({
            value: respObj,
            text: respObj.descripcion,
            disabled: false,
          }));
        }
        this.isLoadingZone = false;
      });
  }
  public async getUserContacts(userId: string) {
    this.wsdlService
      .GetUserContacts(userId)
      .then((resp: AxiosResponse<any>) => {
        this.contacts = resp.data == null ? [] : resp.data;
        this.contactsArray = [...this.contacts];
        for (var i = this.contacts.length - 1; i < 4; i++) {
          var emptyContact = new AfpUserContact();
          this.contactsArray.push(emptyContact);
        }
        this.contacts[0].isExpanded = true;
      })
      .finally(() => {
        this.loadContacts = true;
      });
  }
  async getData() {
    this.actualizacionDatos = await this.umbracoService.getActualizacionDatos();
  }
  returnHome() {
    this.$router.push("Dashboard");
  }

  extractEmailParts(email: string): { usuario: string; servidor: string } {
    const [usuario, servidor] = email.trim().split("@");
    return {
      usuario: usuario || "",
      servidor: servidor || "",
    };
  }

  async process() {
    if (!this.checkProcesar) {
      Swal.fire({
        text: "Debe aceptar los teminos y condiciones para procesar su solicitud",
        icon: "info",
        showConfirmButton: true,
        confirmButtonText: "Ok",
      });
      return;
    }
    this.isProcessing = true;
    const emailError = EmailValidator.validate(this.afpUser.emailusuario);
    if (emailError) {
      Swal.fire({
        text: emailError,
        icon: "warning",
        confirmButtonText: "Ok",
      });
      this.isProcessing = false;
      return;
    }
    if (!this.isEmailValid) {
      alert("El campo E-mail no es válido.");
      this.isProcessing = false;
      return;
    }
    await this.updateUser()
      .then(async () => {
        await this.updateUserContacts();
      })
      .then(() => {
        this.$router.push("result-actualizacion-datos");
      })
      .catch(() => {
        Swal.fire({
          text: "Ha ocurrido un error con la comunicación",
          icon: "error",
          showConfirmButton: true,
          confirmButtonText: "Ok",
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }
  async updateUser() {
    const emailError = EmailValidator.validate(this.afpUser.emailusuario);
    if (emailError) {
      Swal.fire({
        text: "El correo ingresado no es válido: " + emailError,
        icon: "warning",
        confirmButtonText: "Ok",
      });
      this.isProcessing = false;
      return;
    }
    this.afpUser.cedula = this.userId;
    this.afpUser.codusuario = this.userId;
    const partes = this.extractEmailParts(this.afpUser.emailusuario);
    this.afpUser.emailusuario = partes.usuario;
    this.afpUser.emailservidor = partes.servidor;
    this.afpUser.ciudad1 = this.cityHome?.descripcion;
    this.afpUser.ciudad2 = this.cityWork?.descripcion;
    this.afpUser.codciudaD1 = this.cityHome?.ciudad;
    this.afpUser.codciudaD2 = this.cityWork?.ciudad;

    this.afpUser.codsectoR1 = this.zoneHome?.sector;
    this.afpUser.codsectoR2 = this.zoneWork?.sector;
    this.afpUser.sector1 = this.zoneHome?.descripcion;
    this.afpUser.sector2 = this.zoneWork?.descripcion;
    this.afpUser.codusuario = this.userId;
    await this.wsdlService
      .postActualizarInfoUsuario(this.afpUser)
      .then((resp) => {
        debugger;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async updateUserContacts() {
    let user = new AfpUserServiceContact();
    this.contactsArray.forEach((element) => {
      user.contacts.push({
        idSec: element.idsec,
        cedula: element.cedulacontacto,
        parentesco: element.parentescocontacto,
        nombre: element.nombrecontacto,
        direccion: element.direccioncontacto,
        telefono: element.telefonocontacto,
        email: element.emailcontacto,
        menor: element.esmenor,
      } as UserContact);
    });
    user.cedula = this.userId;
    await this.wsdlService.postContactosUsuario(user).catch((err) => {
      console.error(err);
    });
  }
  // async updateUserContacts() {
  //     let user = new AfpUserServiceContact();
  //     const errores: string[] = [];

  //     for (const element of this.contactsArray) {
  //         // const emailError = EmailValidator.validate(element.emailcontacto);

  //         // if (emailError) {
  //         //     errores.push(
  //         //         `Contacto: ${element.nombrecontacto} – ${emailError}`
  //         //     );
  //         // } else {
  //             user.contacts.push({
  //                 idSec: element.idsec,
  //                 cedula: element.cedulacontacto,
  //                 parentesco: element.parentescocontacto,
  //                 nombre: element.nombrecontacto,
  //                 direccion: element.direccioncontacto,
  //                 telefono: element.telefonocontacto,
  //                 email: element.emailcontacto,
  //                 menor: element.esmenor
  //             } as UserContact);
  //         // }
  //     }

  //     // if (errores.length > 0) {
  //     //     Swal.fire({
  //     //         title: "Correos inválidos",
  //     //         html: `<ul style="text-align:left;">${errores
  //     //             .map((e) => `<li>${e}</li>`)
  //     //             .join("")}</ul>`,
  //     //         icon: "warning",
  //     //         confirmButtonText: "Ok",
  //     //     });
  //     //     return;
  //     // }

  //     user.cedula = this.userId;

  //     await this.wsdlService
  //         .postContactosUsuario(user)
  //         .catch((err) => {
  //             console.error(err);
  //         });
  // }

  @Watch("city")
  public async onCityChange(value: CityResponse) {
    await this.getZones(value.ciudad, "", true);
  }
  @Watch("cityHome")
  public async onCityChangeHome(value: CityResponse) {
    await this.getZones(value.ciudad, "", true);
  }
  @Watch("cityWork")
  public async onCityChangeWork(value: CityResponse) {
    await this.getZones(value.ciudad, "", false);
  }
  @Watch("selectedCityHome")
  public async onSelectedCityHomeChanged(value: CityResponse) {
    this.cityHome = value;
    await this.getZones(value?.ciudad || "", "", true);
  }

  @Watch("selectedCityWork")
  public async onSelectedCityWorkChanged(value: CityResponse) {
    this.cityWork = value;
    await this.getZones(value?.ciudad || "", "", false);
  }

  @Watch("selectedZoneHome")
  public onSelectedZoneHomeChanged(value: ZoneResponse) {
    this.zoneHome = value;
  }

  @Watch("selectedZoneWork")
  public onSelectedZoneWorkChanged(value: ZoneResponse) {
    this.zoneWork = value;
  }

  @Watch("cities")
  public onCitiesChange() {
    if (this.afpUser?.codciudaD1?.length > 0) {
      const cityHomeFiltered = this.cities.find(
        (city) => city.value.ciudad === this.afpUser.codciudaD1
      );
      this.cityHome = cityHomeFiltered?.value || null;
      this.selectedCityHome = cityHomeFiltered?.value || null;
      console.log("CITY HOME (observer)", this.cityHome);
    }

    if (this.afpUser?.codciudaD2?.length > 0) {
      const cityWorkFiltered = this.cities.find(
        (city) => city.value.ciudad === this.afpUser.codciudaD2
      );
      this.cityWork = cityWorkFiltered?.value || null;
      this.selectedCityWork = cityWorkFiltered?.value || null;
      console.log("CITY WORK (observer)", this.cityWork);
    }
  }

  @Watch("zonesHome")
  onZonesHomeChange() {
    if (this.afpUser && this.afpUser.codsectoR1?.length > 0) {
      const cityZoneFiltered = this.zonesHome.find(
        (zone) => zone.value.sector === this.afpUser.codsectoR1
      );
      this.zoneHome = cityZoneFiltered?.value || null;
      this.selectedZoneHome = cityZoneFiltered?.value || null;
    }
  }
  @Watch("zonesWork")
  onZonesWorkChange() {
    if (this.afpUser && this.afpUser.codsectoR2?.length > 0) {
      const workZoneFiltered = this.zonesWork.find(
        (zone) => zone.value.sector === this.afpUser.codsectoR2
      );
      this.zoneWork = workZoneFiltered?.value || null;
      this.selectedZoneWork = workZoneFiltered?.value || null;
    }
  }

  @Watch("email")
  onafpUserChange() {
    this.ValidateEmail();
  }

  // public validateInput(){
  //     console.log("entro");
  //     const input = document.querySelector('#x_Email_Usuario') ;
  //     input.addEventListener('load', (e) => {
  //     const eventTarget = e.target as HTMLInputElement;
  //     const isValid = eventTarget.checkValidity();
  //     this.isEmailValid = isValid;
  //     alert("load"+isValid)
  //     });
  //     input.addEventListener('change', (e) => {
  //     const eventTarget = e.target as HTMLInputElement;
  //     const isValid = eventTarget.checkValidity();
  //     this.isEmailValid = isValid;
  //     alert("change"+isValid)
  //     });
  // }

  public separateEmail() {
    this.afpUser.emailusuario = this.email.split("@")[0];
    this.afpUser.emailservidor = this.email.split("@")[1];
    console.log(this.email);
    console.log(this.afpUser.emailusuario);
    console.log(this.afpUser.emailservidor);
  }
  public ValidateEmail() {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
      this.isEmailValid = true;
      this.separateEmail();
      return true;
    }
    this.isEmailValid = false;
    return false;
  }
  public uuidv4(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }
}
